//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";


const getTokenList = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/gateway/credentials");
}
const createToken = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/gateway/token");
}
const downloadToken = (clinicId,tokenId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/gateway/token/"+tokenId+"/downloads",{ responseType: 'blob' });
}
const blockToken = (clinicId, tokenId)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/gateway/credentials/"+tokenId+"/block-access");
}
const unblockToken = (clinicId, tokenId)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/gateway/credentials/"+tokenId+"/unblock-access");
}

export default {
   getTokenList,
   createToken,
   downloadToken,
   blockToken,
   unblockToken,
}